<template>
  <footer class="footer">
    <div class="footer-contact">
      <div class="footer-contact-left">
        <h2 v-html="translations.footer.contact.title"></h2>
        <p>{{ translations.footer.contact.subtitle }}</p>
        <!-- ZAMIANA: numer jako link + tracking -->
        <p>
          {{ translations.footer.contact.call }} -
          <a href="tel:+48720992745" @click="trackPhone">+48 720 992 745</a>
        </p>
        <p>
          {{ translations.footer.contact.write }} -
          <a href="mailto:biuro@birdstool.pl" @click="trackEmail">biuro@birdstool.pl</a>
        </p>
      </div>

      <form class="footer-contact-form" @submit.prevent="sendContact">
        <input v-model="form.email" type="email" :placeholder="translations.footer.form.email_placeholder" required />
        <input v-model="form.phone" type="text" :placeholder="translations.footer.form.phone_placeholder" />
        <textarea v-model="form.message" :placeholder="translations.footer.form.message_placeholder" rows="4" required></textarea>
        <button type="submit" :disabled="loading">{{ translations.footer.form.button }}</button>

        <AppToast
          v-if="success"
          :title="translations.footer.form.success_title"
          :message="translations.footer.form.success_message"
          :duration="3000"
        />
      </form>
    </div>

    <div class="footer-links">
      <div class="footer-column contact-info">
        <h4>{{ translations.footer.info.title }}</h4>
        <p><a href="tel:+48720992745" @click="trackPhone">+48 720 992 745</a></p>
        <p><a href="mailto:biuro@birdstool.pl" @click="trackEmail">biuro@birdstool.pl</a></p>
        <p>BIRDSOFT sp. z o.o.</p>
        <p>PL6222856070</p>
        <p>ul. Kaliska 35A/210<br>Ostrów Wielkopolski</p>
        <p>POLSKA</p>
      </div>

      <div class="footer-column">
        <h4>{{ translations.footer.about.title }}</h4>
        <a href="/kontakt">{{ translations.footer.about.kontakt }}</a>
        <a href="/uslugi">{{ translations.footer.about.uslugi }}</a>
        <a href="/wysylka">{{ translations.footer.about.wysylka }}</a>
        <a href="/zwrot">{{ translations.footer.about.zwrot }}</a>
        <a href="/regulamin">{{ translations.footer.about.regulamin }}</a>
        <a href="/polityka">{{ translations.footer.about.polityka }}</a>
      </div>

      <div class="footer-column social-media">
        <h4>{{ translations.footer.social.title }}</h4>
        <div class="icons">
          <a href="https://www.facebook.com/birdstoolpl/">Facebook</a>
          <a href="https://www.instagram.com/birdstool_pl/">Instagram</a>
        </div>
      </div>
    </div>

    <div class="footer-bottom">
      <span>© 2025 Dawid Panas - +48 720 992 745. {{ translations.footer.copyright }}</span>
    </div>
  </footer>
</template>

<script setup>
import { ref } from 'vue'
import AppToast from './AppToast.vue'
import { translations } from '@/locales/lang'
import { track } from '@/tracking/events'

const form = ref({ email: '', phone: '', message: '' })
const loading = ref(false)
const success = ref(false)

async function sendContact() {
  loading.value = true
  success.value = false
  try {
    const res = await fetch('https://birdstool.pl/api/v1/contact-request/', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(form.value)
    })
    if (!res.ok) throw new Error('Błąd serwera')

    form.value.email = ''
    form.value.phone = ''
    form.value.message = ''
    success.value = true

    // Lead – sukces
    track.lead({ formId: 'footer-contact', status: 'submitted' })
  } catch (e) {
    console.error(e)
    // Lead – niepowodzenie (przydaje się do diagnostyki)
    track.lead({ formId: 'footer-contact', status: 'failed' })
  } finally {
    loading.value = false
  }
}

// FUNKCJE MUSZĄ BYĆ POZA sendContact, żeby były widoczne w <template>
function trackPhone() { track.contactClick('phone', '+48720992745') }
function trackEmail() { track.contactClick('email', 'biuro@birdstool.pl') }
</script>

<style scoped>
/* tu ewentualne style */
</style>
